module.exports = __webpack_public_path__ + "img/sti-dest-sc.bfe10536.svg";